module.exports = __webpack_public_path__ + "img/save.1d404d27.svg";